import React from 'react'
import Pagination from '../../Hocs/Pagination'

import Page1 from './page1'
import Page2 from './page2'
import Page3 from './page3'
import Page4 from './page4'

export default Pagination({
  numberOfSlides: (props) => {
    if (props.financials.summary.length > 6) {
      return 5
    }
    return 4
  },
  renderItem: (props, index) => {
    const {
      currentPage,
      financials: {
        summary,
        groupBalanceSheet,
        groupProfitAndLoss,
        divisionProfitAndLoss,
        denomination,
        fundsMgmtIncomeEnabled,
        investmentExperienceEnabled,
        specialProjectsEnabled,
        creditCardsEnabled,
        institutionalBankingEnabled,
        offshoreBankEnabled
      }
    } = props

    const { length } = summary
    let maxPerPage = 6
    if (length > 6 && length <= 8) {
      maxPerPage = 4
    }

    const hasMultipleSummaryPages = length > 6

    const items1 = summary.slice(0, maxPerPage)
    const items2 = summary.slice(maxPerPage)

    const indexOffset = hasMultipleSummaryPages ? 1 : 0

    if (index === 0) {
      return <Page1 items={items1} denomination={denomination} active={currentPage === 0} maxPerPage={maxPerPage} />
    } else if (hasMultipleSummaryPages && index === 1) {
      return <Page1 items={items2} denomination={denomination} active={currentPage === 1} maxPerPage={maxPerPage} />
    } else if (index - indexOffset === 1) {
      return <Page2 data={groupProfitAndLoss} divisions={divisionProfitAndLoss.businesses} fundsMgmtIncomeEnabled={fundsMgmtIncomeEnabled} investmentExperienceEnabled={investmentExperienceEnabled} specialProjectsEnabled={specialProjectsEnabled} denomination={denomination} round={props.selectedRound} active={currentPage - indexOffset === 1} />
    } else if (index - indexOffset === 2) {
      return <Page3 data={divisionProfitAndLoss} fundsMgmtIncomeEnabled={fundsMgmtIncomeEnabled} creditCardsEnabled={creditCardsEnabled} institutionalBankingEnabled={institutionalBankingEnabled} denomination={denomination} round={props.selectedRound} active={currentPage - indexOffset === 2} />
    } else if (index - indexOffset === 3) {
      return <Page4 data={groupBalanceSheet} fundsMgmtIncomeEnabled={fundsMgmtIncomeEnabled} investmentExperienceEnabled={investmentExperienceEnabled} offshoreBankEnabled={offshoreBankEnabled} creditCardsEnabled={creditCardsEnabled} institutionalBankingEnabled={institutionalBankingEnabled} denomination={denomination} round={props.selectedRound} active={currentPage - indexOffset === 3} />
    }
  }
})
